import { css } from 'styled-components';

import { mediaQueries } from '../breakpoints';

export const media = Object.entries(mediaQueries).reduce(
  (acc, [key, query]) => {
    acc[key] = (...args) => css`
      @media (${query}) {
        ${css(...args)};
      }
    `;
    return acc;
  },
  {}
);
